import React, { useState } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../assets/images/logo.png";
import { menuData } from "../data/header";
import SymbolSearchDialog from "../components/SymbolSearchDialog";
import PSXTicker from "../components/PSXTicker";

function HeaderNavigation() {
  const location = useLocation();
  const history = useHistory();
  const [searchOpen, setSearchOpen] = useState(false);

  const handleSymbolSelect = (item) => {
    history.push(`/trading-dashboard/${item.code}`);
  };

  return (
    <>

      {/* ══ BAND 1: Logo + Contact + CTA ══ */}
      <div className="hdr-top">
        {/* ══ BAND 0: Live ticker strip ══ */}
        <div className="hdr-ticker-band">
          <PSXTicker />
        </div>
        <div className="hdr-top-inner">

          {/* Logo */}
          <a href="/" className="hdr-logo-link">
            <img src={logo} alt="Orbit Securities" className="hdr-logo" />
          </a>

          {/* Right side: contacts + open account */}
          <div className="hdr-top-right">

            {/* Call Us box */}
            <div className="hdr-callus">
              <div className="hdr-callus-label">Call Us</div>
              <div className="hdr-callus-numbers">
                <span className="hdr-phone">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
                  </svg>
                  +92-333-529-9117
                </span>
                <span className="hdr-phone">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.477 2 2 6.477 2 12v3a3 3 0 003 3h1v-6H4v-1a8 8 0 1116 0v1h-2v6h1a3 3 0 003-3v-3c0-5.523-4.477-10-10-10zm-7 11a1 1 0 00-1 1v2a1 1 0 001 1h1v-4H5zm14 0h-1v4h1a1 1 0 001-1v-2a1 1 0 00-1-1z" />
                    <path d="M9 19a3 3 0 003 3h2v-2h-2a1 1 0 01-1-1H9z" />
                  </svg>
                  +92-333-529-9121
                </span>
              </div>
            </div>

            <div className="hdr-vert-divider" />

            {/* Open Account */}
            <div className="hdr-account-group">
              <div className="hdr-account-label">Open New Account</div>
              <div className="hdr-account-btns">
                <a
                  href="https://www.asaanconnect.com/cdc/cgp/r/centralized-gateway-portal/home"
                  target="_blank" rel="noopener noreferrer"
                  className="hdr-btn-solid"
                >
                  Via CDC
                </a>
                <a
                  href="https://www.aof.com.pk/?MTg2MjgyNTQzNzY0OTc5MjI4MzQyODYyNTI1NDY4NjQ4NDYyNzcyNw=="
                  target="_blank" rel="noopener noreferrer"
                  className="hdr-btn-outline"
                >
                  Via Orbit
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ══ BAND 2: Nav menu + Search ══ */}
      <div className="hdr-nav-band">
        <div className="hdr-nav-inner">
          <Navbar expand="lg" className="hdr-navbar">
            <Navbar.Toggle aria-controls="hdr-nav-collapse" className="hdr-toggler" />
            <Navbar.Collapse id="hdr-nav-collapse">
              <Nav className="hdr-nav-links">
                {menuData.map((menu, index) => {
                  const isActive = menu.items.some(item => location?.pathname === item.link);
                  return (
                    <NavDropdown
                      key={index}
                      className="hdr-dropdown"
                      title={
                        <span className={`hdr-nav-title${isActive ? " hdr-nav-active" : ""}`}>
                          {menu.title}
                        </span>
                      }
                      id={`hdr-dd-${index}`}
                    >
                      {menu.items.map((item, i) => (
                        <NavDropdown.Item
                          key={i}
                          as={NavLink}
                          to={item.link}
                          className={({ isActive }) =>
                            `hdr-dd-item${isActive ? " hdr-dd-active" : ""}`
                          }
                        >
                          {item.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  );
                })}
              </Nav>

              {/* Search — pushed to far right */}
              <button
                className="hdr-search-btn"
                onClick={() => setSearchOpen(true)}
                aria-label="Search stock symbols"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.2"
                  strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                Search symbols
              </button>

            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>

      <SymbolSearchDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onSelect={handleSymbolSelect}
      />
    </>
  );
}

export default HeaderNavigation;